export const Hero = ({ title, subtitle }) => (
    <header className="bg-gradient-to-r from-green-600 via-green-700 to-green-500 text-white">
        <div className="max-w-6xl mx-auto px-1 py-16 lg:py-32">
            <div className=" p-8 sm:p-12 ">
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
                    {title}
                </h1>
                <p className="mt-4 text-lg sm:text-xl opacity-90">{subtitle}</p>
                <div className="mt-6 flex gap-3">
                    <a
                        href="#content"
                        className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-md text-sm font-medium hover:bg-white/20"
                    >
                        مشاهده محتوا
                    </a>
                </div>
            </div>
        </div>
    </header>
);

export const PageContainer = ({ children }) => (
    <main id="content" className=" py-12">
        <div className="max-w-6xl mx-auto px-1">
            <div className="  p-8 sm:p-12 ">
                {children}
            </div>
        </div>
    </main>
);